import { CANTRATE_ID } from '@webapp/common/resources/constants';

import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

import type { ResponseEventParams } from '../../entities/response-machine';
import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class SelectOneImageApi extends QuestionSimpleApi {
    public change(question: QuestionContext, evt: ResponseEventParams): void {
        const { value, questionId, answerId } = evt;
        const { answersActors, responseActor } = question;

        if (value === CANTRATE_ID) {
            answersActors.forEach((answersActor) => {
                const otherAnswer = answersActor.getSnapshot().context;
                otherAnswer.response?.send({ type: 'SET', value: false });
            });
        } else if (value) {
            responseActor.send({ type: 'CHANGE', value, questionId });

            answersActors.forEach((answersActor) => {
                const otherAnswer = answersActor.getSnapshot().context;
                if (answerId !== otherAnswer.id) {
                    otherAnswer.response?.send({ type: 'SET', value: false });
                }
            });
        }
    }

    public query(questionActor: QuestionActor): AnswersRequest {
        const { id, answersActors, responseActor } = questionActor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        let data;

        if (value === CANTRATE_ID) {
            data = [{ cantRate: true, bool: true }];
        } else {
            data = answersActors.map((answersActor) => {
                const { id, response: responseActor } = answersActor.getSnapshot().context;
                const response = responseActor.getSnapshot().context;
                return { answer: id, bool: (response.value as boolean) || false };
            });
        }

        return {
            question: id,
            data,
            comment,
        };
    }

    public validate({ answersActors, params: { required }, responseActor }: QuestionContext): boolean {
        const response = responseActor.getSnapshot().context;

        if (!required || Number(response.value) === CANTRATE_ID) return true;

        return answersActors.some((answer) => !!answer.getSnapshot().context.response.getSnapshot().context.value);
    }
}
